import { render } from "./RadarComparisonChart.vue?vue&type=template&id=0401421c&scoped=true&ts=true"
import script from "./RadarComparisonChart.vue?vue&type=script&lang=ts"
export * from "./RadarComparisonChart.vue?vue&type=script&lang=ts"

import "./RadarComparisonChart.vue?vue&type=style&index=0&id=0401421c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0401421c"]])

export default __exports__